<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<label *ngIf="model$ | async as model" class="form-group cx-sort-dropdown">
  <span class="d-none d-lg-inline-block">{{ 'productList.sortBy' | cxTranslate }}</span>
  <cx-sorting
    [sortOptions]="model.sorts"
    (sortListEvent)="sortList($event)"
    [selectedOption]="model.pagination?.sort"
    [ariaLabel]="'productList.sortResults' | cxTranslate"
    ariaControls="product-results-list"
    placeholder="{{ 'productList.sortBy' | cxTranslate }}"
  ></cx-sorting>
</label>
